import { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "电影分类", to: "/category" },
  { label: "相关推荐", to: "/recommendations" },
  { label: "关于本站", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [keyword, setKeyword] = useState("");

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [navigate]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (!q) return;
    navigate(`/search?q=${encodeURIComponent(q)}`);
    setMenuOpen(false);
    setKeyword("");
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || menuOpen
          ? "bg-background-950/95 backdrop-blur border-b border-background-800"
          : "bg-gradient-to-b from-background-950/80 to-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 md:h-20 items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 shrink-0 group">
          <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 text-lg">
            <i className="ri-film-line"></i>
          </span>
          <span className="font-heading font-bold text-base md:text-lg text-foreground-50 whitespace-nowrap">
            交换朋友的妻子
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1 ml-4">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `px-3 py-2 text-sm rounded-md transition-colors whitespace-nowrap ${
                  isActive
                    ? "text-accent-400 font-medium"
                    : "text-foreground-300 hover:text-foreground-50 hover:bg-background-800/70"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="hidden md:flex items-center ml-auto">
          <div className="relative">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影片或演员"
              className="w-56 lg:w-64 rounded-md bg-background-800/80 border border-background-700 pl-9 pr-3 py-2 text-sm text-foreground-100 placeholder:text-foreground-500 focus:outline-none focus:border-primary-400"
            />
          </div>
          <button
            type="submit"
            className="ml-2 px-3 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          aria-label="打开菜单"
          onClick={() => setMenuOpen((v) => !v)}
          className="md:hidden ml-auto w-10 h-10 flex items-center justify-center rounded-md text-foreground-100 text-2xl cursor-pointer"
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden border-t border-background-800 bg-background-950/98 px-4 pb-5 pt-3">
          <form onSubmit={handleSearch} className="flex items-center gap-2 mb-3">
            <div className="relative flex-1">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-500 text-sm"></i>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影片或演员"
                className="w-full rounded-md bg-background-800 border border-background-700 pl-9 pr-3 py-2.5 text-sm text-foreground-100 placeholder:text-foreground-500 focus:outline-none focus:border-primary-400"
              />
            </div>
            <button
              type="submit"
              className="px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              搜索
            </button>
          </form>
          <nav className="flex flex-col">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `px-3 py-3 rounded-md text-sm ${
                    isActive
                      ? "text-accent-400 bg-background-900"
                      : "text-foreground-200 hover:bg-background-900"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}